<script>
import { createNamespacedHelpers } from 'vuex';

import { ROUTE_TRAINER_VIEW_UNBOUND, ROUTE_TRAINER_VIEW_BOUND } from '@/router/names';
import { FETCH_TRAINER } from '@/store/trainer/types';

const { mapState, mapActions } = createNamespacedHelpers('trainer');

export default {
    computed: {
        ...mapState({
            trainer: state => state.trainer || {},
        }),
    },
    created() {
        const { id } = this.$route.params;
        this.fetchTrainer({
            id,
        }).then(() => {
            document.title = `会员：${this.trainer.name}`;

            const nextRoute = this.trainer.wechat_bound ? ROUTE_TRAINER_VIEW_BOUND : ROUTE_TRAINER_VIEW_UNBOUND;
            this.$router.replace({
                name: nextRoute,
                params: {
                    id,
                },
            });
        });
    },
    methods: {
        ...mapActions({
            fetchTrainer: FETCH_TRAINER,
        }),
    },
    render() {
        return null;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/View.vue